import { ICommonTranslation } from "models/translation";

import defaultsWithFallback from "helpers/defaultsWithFallback";
import { ListItemTranslator } from "helpers/translationHelpers";
import { fallbackTranslation } from "services/api/fallbackData";

import { IJobsTableTexts } from "components/JobsTable/JobsTable";

export const readUnreadButtonOptionsKeys = {
  markAsRead: "markAsRead",
  markAsUnread: "markAsUnread",
};

export function prepareTableTexts(
  commonTranslation: ICommonTranslation
): IJobsTableTexts {
  const grid = defaultsWithFallback(
    commonTranslation?.grid,
    fallbackTranslation.common.grid
  );
  const breakdowns = defaultsWithFallback(
    commonTranslation?.breakdowns,
    fallbackTranslation.common.breakdowns
  );
  const buttonOptionsTranslator = new ListItemTranslator(
    commonTranslation?.grid?.readUnreadButtonOptions,
    fallbackTranslation.common.grid.readUnreadButtonOptions
  );

  return {
    resultStats: grid.resultStats,
    refreshResultsLabel: grid.refreshResultsLabel,
    selectAllControlTexts: {
      selectAllAlertsLabel: grid.selectAll,
      markAsReadAlertsLabel: buttonOptionsTranslator.get(
        readUnreadButtonOptionsKeys.markAsRead
      ),
      markAsUnreadAlertsLabel: buttonOptionsTranslator.get(
        readUnreadButtonOptionsKeys.markAsUnread
      ),
    },
    localHire: breakdowns.localHire,
  };
}
